/**
 * This file contains utilities for using client hints for user preference which
 * are needed by the server, but are only known by the browser.
 */
import { getHintUtils } from '@epic-web/client-hints';
import { clientHint as colorSchemeHint } from '@epic-web/client-hints/color-scheme';

const hintsUtils = getHintUtils({
  theme: colorSchemeHint,
  // add other hints here
});

export const { getHints, getClientHintCheckScript } = hintsUtils;
